module.exports = __webpack_public_path__ + "static/media/createMeetKan.cb47f784.jpg";